import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function projectReducer(state = initialState.projects, action) {
    let newState = state;

    switch (action.type) {

        case types.APPROVE_HOURS_PROJECT:
            newState = approveHoursProject(state, action.projectKey, action.taskKey, action.approvedHourKey);

            return newState;

        case types.ARCHIVE_PROJECT:
            if (action.status === 'success'){
                newState = archiveProject(state, action.project);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.CHECK_PROJECT_NAME:
            newState = {
              ...state,
              error: action.data
            };

            return newState;

        case types.CHECK_PROJECT_NAME_CV:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    sameProjects: action.data
                });
            }

            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                });
            }
            return newState;

        case types.CLEAR_ERROR:
            return {
              ...state,
              error: null
            };

        case types.CREATE_PROJECT:
            if (action.status === 'success'){
                newState = createProject(state, action.project);
            }

            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.DELETE_PROJECT:
            if (action.status === 'success'){
                newState = deleteProject(state, action.projectID);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.EDIT_PROJECT:
            if (action.status === 'success'){
                newState = editProject(state, action.project);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.EXPORT_PROJECTS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    loading: false
                });
                let blob = new Blob([action.data], { type: 'text/csv;charset=utf-8;' });
                if (navigator.msSaveBlob) { // supporting IE 10+
                    navigator.msSaveBlob(blob, action.data.fileName + ".csv");
                } else {
                    let link = document.createElement("a");
                    //download field detection (Chrome supproting as of ver. 14, IE supporting as of ver. 13, Firefox supporting as of ver. 20, Safari not supporting, Opera supporting as of ver. 15)
                    if (link.download !== undefined) {
                        let url = URL.createObjectURL(blob);
                        link.setAttribute("href", url);
                        link.setAttribute("download", action.fileName + ".csv");
                        link.style.visibility = 'hidden';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
                return newState;
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.IS_DELETABLE:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    deletable: action.data,
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                });
            }
            return newState;

        case types.LOAD_PROJECTS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    projects: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_PROJECTS_BY_USER:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    projectsByUser: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_MY_PROJECTS_FOR_WEEK_APPROVAL:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    myProjectsForWeekApproval: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_OTHER_PROJECTS_FOR_WEEK_APPROVAL:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    otherProjectsForWeekApproval: action.data,
                    otherProjectsLoading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    otherProjectsLoading: false
                });
            }
            return newState;

        case types.PM_LOAD_ALL_PROJECTS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    allProjects: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PM_LOAD_ALL_PROJECTS_WITHOUT_TASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    allProjectsWithoutTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PM_LOAD_ARCHIVED_PROJECTS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    archivedProjects: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PM_LOAD_UNARCHIVED_PROJECTS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    unarchivedProjects: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_LOAD_ALL_PROJECTS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    allProjects: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_LOAD_ALL_PROJECTS_FOR_USERS_OVERVIEW:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    projectsForUsersOverview: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_LOAD_ARCHIVED_PROJECTS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    archivedProjects: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_LOAD_UNARCHIVED_PROJECTS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    unarchivedProjects: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }

            return newState;

        case types.REJECT_APPROVED_HOURS:
            if (action.status === 'success'){
                newState = rejectApprovedHours(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_LOADING_FLAG_FOR_PROJECT_STATE:
            return Object.assign({}, state, {
                loading: true
            });

        case types.SET_LOADING_FLAG_FOR_OTHER_PROJECT_STATE:
            return Object.assign({}, state, {
                otherProjectsLoading: true
            });

        case types.SET_CURRENT_VIEW:
            return Object.assign({}, state, {
                currentView: action.viewName
            });

        case types.SET_SELECTED_PROJECT:
            return Object.assign({}, state, {
                selectedProject: action.project
            });

        case types.UNARCHIVE_PROJECT:
            if (action.status === 'success'){
                newState = unarchiveProject(state, action.project);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

      case  types.GET_UNBILLED_TIME_ON_PROJECT:
          if (action.status === 'success') {
            newState = Object.assign({}, state, {
              unbilledHours: action.data
            })
          }
          if (action.status === 'failure'){
            newState = Object.assign({}, state, {
              error: action.data,
            });
          }
          return newState

        default:
            return state;
    }
}

function approveHoursProject (state, projectKey, taskKey, approvedHourKey) {
    let myProjects = JSON.parse(JSON.stringify(state.myProjectsForWeekApproval));

    myProjects[projectKey].toApprove--;
    myProjects[projectKey].tasks[taskKey].toApprove--;
    myProjects[projectKey].tasks[taskKey].approvedHours[approvedHourKey].approvable = false;
    myProjects[projectKey].tasks[taskKey].approvedHours[approvedHourKey].status = "APPROVED";

    let newState = Object.assign({}, state, {
        myProjectsForWeekApproval: myProjects
    });

    return newState;
}

function archiveProject (state, project) {
    let indexUnarchived = list.findIndexByID(state.unarchivedProjects, project.id);
    let unarchivedProjects = list.remove(state.unarchivedProjects, indexUnarchived);

    let newState = Object.assign({}, state, {
        loading: false,
        unarchivedProjects: unarchivedProjects,
        archivedProjects: [...state.archivedProjects, project]
    });
    return newState;
}

function createProject (state, project) {
    return Object.assign({}, state, {
        loading: false,
        activeProject: project,
        unarchivedProjects: [...state.unarchivedProjects, project]
    });
}

function deleteProject (state, projectID) {
    let archivedProjects = state.archivedProjects;
    let unarchivedProjects = state.unarchivedProjects;

    let indexArchived = list.findIndexByID(archivedProjects, projectID);
    let indexUnarchived = list.findIndexByID(unarchivedProjects, projectID);

    if(indexArchived) {
        archivedProjects = list.remove(archivedProjects, indexArchived);
    }

    if(indexUnarchived) {
        unarchivedProjects = list.remove(unarchivedProjects, indexUnarchived);
    }

    let newState = Object.assign({}, state, {
        loading: false,
        archivedProjects: archivedProjects,
        unarchivedProjects: unarchivedProjects
    });

    return newState;
}

function editProject (state, project) {
    let unarchivedProjects = state.unarchivedProjects;
    let archivedProjects = state.archivedProjects;
    let indexUnarchived = list.findIndexByID(unarchivedProjects, project.id);

    if(indexUnarchived) {
        unarchivedProjects[indexUnarchived] = project;
    }
    else {
        let indexArchived = list.findIndexByID(archivedProjects, project.id);
        if(indexArchived) {
            archivedProjects[indexArchived] = project;
        }
    }

    let newState = Object.assign({}, state, {
        loading: false,
        archivedProjects: archivedProjects,
        unarchivedProjects: unarchivedProjects,
    });

    return newState;
}

function rejectApprovedHours (state, data) {

    let myProjectsForWeekApproval = state.myProjectsForWeekApproval;
    myProjectsForWeekApproval.map((project) => {
        project.tasks.map((task => {
            task.approvedHours.map((approvedHour) => {
                if(approvedHour.aphID === data.approvedHoursID) {
                    approvedHour.rejectMessage = data.rejecter.givenName + " " + data.rejecter.surname + ": " + data.message;
                    approvedHour.timeApproved = 0;
                    approvedHour.timePrevRejected = approvedHour.regularTime;
                    approvedHour.overtimePrevRejected = approvedHour.overtime;
                    approvedHour.rejectedAt = data.rejectedAt;
                    approvedHour.approvable = false;
                }
            });
        }));
    });



    let newState = Object.assign({}, state, {
        loading: false,
        myProjectsForWeekApproval
    });
    return newState;
}

function unarchiveProject (state, project) {
    let indexArchived = list.findIndexByID(state.archivedProjects, project.id);
    let archivedProjects = list.remove(state.archivedProjects, indexArchived);

    let newState = Object.assign({}, state, {
        loading: false,
        archivedProjects: archivedProjects,
        unarchivedProjects: [...state.unarchivedProjects, project]
    });
    return newState;
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/projectReducer.js
 **/